export interface GasData {
  maxFeePerGas: string
  maxPriorityFeePerGas: string
  erc20ApproveGas: string
  erc20TransferGas: string
  ethDepositGas: string
  ethTransferGas: string
  erc20DepositGas: string
}

export enum TransactionType {
  ETH,
  TRANSFER,
  APPROVE,
  DEPOSIT,
  CONTRACT_CALL,
}

interface AbiParameter {
  internalType: string
  name: string
  type: string
}

export interface ContractInfo {
  gasLimit?: bigint
  name?: string
  functionType?: 'payable' | 'nonpayable' | 'view' | 'pure'
  inputs?: AbiParameter[]
  params?: {
    [key: string]: unknown
    __length__: number
  }
  value?: string
}

export type TokenData = {
  decimals: number
  logo: string
  name: string
  symbol: string
  type: TransactionType
  to: string
  value: number
}
